import { Store } from 'vuex';
import { SaveableObject, findSaveableTypeDescriptor } from '@/app-modules/store/modules';
import { StoreConfiguration } from '@/app-modules/store/persisted-store/store-configuration';
import { injectable } from 'inversify';

interface IPersistedStore {
  Get<T extends SaveableObject>(type: new () => T): T;
  Save<T extends SaveableObject>(...models: T[]): void;
  Remove<T extends SaveableObject>(type: new() => T): void;
}

@injectable()
class PersistedStore implements IPersistedStore {
  private readonly storeConfiguration: StoreConfiguration;
  private readonly store: Store<any>;

  constructor() {
    this.storeConfiguration = new StoreConfiguration();
    this.store = this.storeConfiguration.getStore();
  }

  public Get<T extends SaveableObject>(type: new () => T): T {
    const descriptor = findSaveableTypeDescriptor(type);
    return this.store.getters[`${descriptor.name}/get`];
  }

  public Save<T extends SaveableObject>(...models: T[]): void {
    for (const model of models) {
      const constructorFunc = model.constructor as new () => SaveableObject;
      const descriptor = findSaveableTypeDescriptor(constructorFunc);
      this.store.commit(`${descriptor.name}/save`, model);
    }
  }

  public Remove<T extends SaveableObject>(type: new() => T): void {
    const descriptor = findSaveableTypeDescriptor(type);
    this.store.commit(`${descriptor.name}/reset`);
  }
}

export { IPersistedStore, PersistedStore };



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/app-modules/store/persisted-store/persisted-store.ts